module.exports = __webpack_public_path__ + "img/certificate11.b42ef2cc.png";